module.exports = __webpack_public_path__ + "img/06.0ed41b3a.png";